import '@/js/dist/www.iichi.com/common';

import Vue from 'vue';
import EntryForm from '@/js/components/shop-entry/entry-form.vue';

document.addEventListener('DOMContentLoaded', () => {
  new Vue({
    el: '#entry-form',
    components: {
      EntryForm,
    },
  });
});
